import {post_data} from './API_Calls.js';
import * as RO from "./ReportObjects.js";
import * as RP from "./ReportPlots.js";

export async function getIncidentUuids(userId){
    var param = {
        "user_uuid" : userId
    };

    return await post_data("/get_ReportData", param) || null;
}
export async function getIncidents(incidentList){
    var param = {
        "incident_uuid_list" : incidentList
    };
    return sortAndAssignRowIncident(await post_data("/get_IncidentsCrimeAtSea", param));
}

export function sortAndAssignRowIncident(incidents: RouteIncident[]): RouteIncident[] {
    return incidents
        .sort((a, b) => new Date(b.utc_date_time).getTime() - new Date(a.utc_date_time).getTime()) // Sort by utc_date_time descending
        .map((incident, index) => ({
            ...incident,
            row: index + 1, // Assign row number in descending order
        }));
}

export function assignStatusAndWeaponIncident(incidents: RouteIncident[]): RouteIncident[] {
    return incidents.map((incident) => {
        let updatedIncident = { ...incident };
        try{
        if (!updatedIncident.incident_status || updatedIncident.incident_status === "") {
            if (updatedIncident.status_approached) updatedIncident.incident_status = "Approached";
            else if (updatedIncident.status_boarded) updatedIncident.incident_status = "Boarded";
            else if (updatedIncident.status_fired_upon) updatedIncident.incident_status = "Fired upon";
            else if (updatedIncident.status_hijacked) updatedIncident.incident_status = "Hijacked";
            else if (updatedIncident.status_kidnapped) updatedIncident.incident_status = "Kidnapped";
            else if (updatedIncident.status_robbed) updatedIncident.incident_status = "Robbed";
            else if (updatedIncident.status_suspicious) updatedIncident.incident_status = "Suspicious";
            else if (updatedIncident.status_unknown) updatedIncident.incident_status = "UNKNOWN";
        }

        if (!updatedIncident.incident_weapons || updatedIncident.incident_weapons === "") {
            if (updatedIncident.weapon_blade) updatedIncident.incident_weapons = "Blade";
            else if (updatedIncident.weapon_guns) updatedIncident.incident_weapons = "Gun";
            else if (updatedIncident.weapon_no) updatedIncident.incident_weapons = "None";
            else if (updatedIncident.weapon_rpg) updatedIncident.incident_weapons = "RPG";
            else if (updatedIncident.weapon_unknown) updatedIncident.incident_weapons = "UNKNOWN";
            else if (updatedIncident.weapon_unknown_armed) updatedIncident.incident_weapons = "UNKNOWN ARMED";
            else if (updatedIncident.weapon_other && updatedIncident.weapon_other !== "") updatedIncident.incident_weapons = updatedIncident.weapon_other;
        }
        }
        catch(ex){
            console.error(ex);
        }

        return updatedIncident;
    });
}

export function generateIncidentCharts(incidents){
    const plotData = processIncidents(incidents);
    let incidentPlotList: RO.AllZonePlots[] = [];
    let plotMargin = [20, 0, 0, 0];
    let plotMarginBar = [20, 0, 0, 0];
    let plotSize = [1100, 280];

    incidentPlotList.push(RP.createLineChart(
        plotData.plotIncidents, "All Incidents",
        [{name: "", tickAngle: 90}, {name: "", rangemode:"tozero"}],
        6, [true, true], plotMargin, [500, 320]
    ));

    incidentPlotList.push(RP.createLineChart(
        plotData.plotStatus, "Incident Status",
        [{name: "", tickAngle: 90}, {name: "", rangemode:"tozero", tickAngle:-90}],
        6, [true, true], plotMargin, plotSize
    ));

    incidentPlotList.push(RP.createBarChart(
        plotData.plotStatusTotal, "Incident Status Total",
        [{name: "", tickAngle: 90, showticklabels: false}, {name: "", rangemode:"tozero", showticklabels:true}],
         6, false, plotMarginBar, plotSize
    ));

    incidentPlotList.push(RP.createLineChart(
        plotData.plotTimeOfDay, "Local Time of Day",
        [{name: "", tickAngle: 90}, {name: "", rangemode:"tozero"}],
        6, [true, true], plotMargin, plotSize
    ));
    incidentPlotList.push(RP.createBarChart(
        plotData.plotTimeOfDayTotal, "Local Time of Day Total",
        [{name: "", tickAngle: 90, showticklabels: false}, {name: "", rangemode:"tozero", showticklabels:true}],
         6,false, plotMarginBar, plotSize
    ));
    incidentPlotList.push(RP.createLineChart(
        plotData.plotVesselStatus, "Vessel Status",
        [{name: "", tickAngle: 90}, {name: "", rangemode:"tozero"}],
        6, [true, true], plotMargin, plotSize
    ));
    incidentPlotList.push(RP.createBarChart(
        plotData.plotVesselStatusTotal, "Vessel Status Total",
        [{name: "", tickAngle: 90, showticklabels: false}, {name: "", rangemode:"tozero", showticklabels:true}],
         6, false, plotMarginBar, plotSize
    ));
    incidentPlotList.push(RP.createLineChart(
        plotData.plotVesselTypes, "Vessel Types",
        [{name: "", tickAngle: 90}, {name: "", rangemode:"tozero"}],
        6, [true, true], plotMargin, plotSize
    ));
    incidentPlotList.push(RP.createBarChart(
        plotData.plotVesselTypesTotal, "Vessel Types Total",
        [{name: "", tickAngle: 90, showticklabels: false}, {name: "", rangemode:"tozero", showticklabels:true}],
        6, false, plotMarginBar, plotSize
    ));
    incidentPlotList.push(RP.createLineChart(
        plotData.plotWeapons, "Weapons Observed",
        [{name: "", tickAngle: 90}, {name: "", rangemode:"tozero"}],
        6, [true, true], plotMargin, plotSize
    ));
    incidentPlotList.push(RP.createBarChart(
        plotData.plotWeaponsTotal, "Weapons Observed Total",
        [{name: "", tickAngle: 90, showticklabels: false}, {name: "", rangemode:"tozero", showticklabels:true}],
        6, false, plotMarginBar, plotSize
    ));

   return incidentPlotList;
}

function processIncidents(incidents: RouteIncident[]) {
    const statusTypes = [
        { key: "status_approached", name: "Approached", color: "blue" },
        { key: "status_boarded", name: "Boarded", color: "brown" },
        { key: "status_fired_upon", name: "Fired-Upon", color: "green" },
        { key: "status_hijacked", name: "Hijacked", color: "purple" },
        { key: "status_kidnapped", name: "Kidnapped", color: "pink" },
        { key: "status_robbed", name: "Robbed", color: "orange" },
        { key: "status_suspicious", name: "Suspicious Sighting", color: "black" },
        { key: "status_unknown", name: "Unknown", color: "gray" }
    ];
    const timeOfDayTypes = [
        { key: "day", name: "Day", color: "blue" },
        { key: "night", name: "Night", color: "brown" },
        { key: "sunriseset", name: "Sunrise / Set", color: "green" },
        { key: "unknown", name: "Unknown / not clear", color: "purple" },
    ];
    const weaponTypes = [
        { key: "weapon_blade", name: "Blade", color: "red" },
        { key: "weapon_guns", name: "Guns", color: "darkred" },
        { key: "weapon_no", name: "No Weapon", color: "gray" },
        { key: "weapon_rpg", name: "RPG", color: "brown" },
        { key: "weapon_unknown", name: "Unknown", color: "black" },
        { key: "weapon_unknown_armed", name: "Unknown Armed", color: "orange" },
    ];

    const countsByMonth: Record<string, number> = {};
    const countsByTimeOfDay: Record<string, number> = {};
    const countsByTimeOfDayByMonth: Record<string, Record<string, number>> = {};
    const countsByStatus: Record<string, number> = {};
    const countsByStatusByMonth: Record<string, Record<string, number>> = {};
    const countsByVesselStatus: Record<string, number> = {};
    const countsByVesselStatusByMonth: Record<string, Record<string, number>> = {};
    const countsByVesselType: Record<string, number> = {};
    const countsByVesselTypeByMonth: Record<string, Record<string, number>> = {};
    const countsByWeapon: Record<string, number> = {};
    const countsByWeaponByMonth: Record<string, Record<string, number>> = {};
    const months: string[] = [];

    incidents.forEach((incident) => {
        const date = new Date(incident.utc_date_time);
        const timeOfDay = getTimeOfDayCategory(incident.time_of_day);
        const monthYear = `${date.getUTCFullYear()}-${(date.getUTCMonth() + 1).toString().padStart(2, '0')}`;
        countsByMonth[monthYear] = (countsByMonth[monthYear] || 0) + 1;
        const vesselStatus = incident.victim_vessel_status || "Unknown";
        const vesselType = incident.victim_vessel_type || "Unknown";

        if (!countsByStatusByMonth[monthYear]) {
            countsByStatusByMonth[monthYear] = {};
            statusTypes.forEach(({ key }) => (countsByStatusByMonth[monthYear][key] = 0));
        }

        statusTypes.forEach(({ key }) => {
            if(!countsByStatus[key]) countsByStatus[key] = 0;
            if (incident[key]) {
                countsByStatusByMonth[monthYear][key]++;
                countsByStatus[key]++;
            }
        });


        if (!countsByTimeOfDayByMonth[monthYear]) {
            countsByTimeOfDayByMonth[monthYear] = {};
            timeOfDayTypes.forEach(({ key }) => (countsByTimeOfDayByMonth[monthYear][key] = 0));
        }
        countsByTimeOfDayByMonth[monthYear][timeOfDay]++;
        if (!countsByTimeOfDay[timeOfDay]) countsByTimeOfDay[timeOfDay] = 0;
        countsByTimeOfDay[timeOfDay]++;

        if (!countsByVesselStatus[vesselStatus]) {
            countsByVesselStatus[vesselStatus] = 0;
        }
        countsByVesselStatus[vesselStatus]++;

        if (!countsByVesselStatusByMonth[monthYear]) countsByVesselStatusByMonth[monthYear] = {};
        if (!countsByVesselStatusByMonth[monthYear][vesselStatus]) {
            countsByVesselStatusByMonth[monthYear][vesselStatus] = 0;
        }
        countsByVesselStatusByMonth[monthYear][vesselStatus]++;

        if (!countsByVesselType[vesselType]) countsByVesselType[vesselType] = 0;
        countsByVesselType[vesselType]++;

        if (!countsByVesselTypeByMonth[monthYear]) countsByVesselTypeByMonth[monthYear] = {};
        if (!countsByVesselTypeByMonth[monthYear][vesselType]) countsByVesselTypeByMonth[monthYear][vesselType] = 0;
        countsByVesselTypeByMonth[monthYear][vesselType]++;

        if (!countsByWeaponByMonth[monthYear]) {
            countsByWeaponByMonth[monthYear] = {};
            weaponTypes.forEach(({ key }) => (countsByWeaponByMonth[monthYear][key] = 0));
        }

        weaponTypes.forEach(({ key }) => {
            if (!countsByWeapon[key]) countsByWeapon[key] = 0;
            if (incident[key]) {
                countsByWeaponByMonth[monthYear][key]++;
                countsByWeapon[key]++;
            }
        });

        if (!months.includes(monthYear)) {
            months.push(monthYear);
        }
    });
    const totalPerMonth = months.map((month) => countsByMonth[month] || 0);

    const plotIncidentsDataset = [{ name:"Incidents", x:months, y:totalPerMonth, color: "", type:"line"}];

    const plotStatusDataset = statusTypes.map(({ key, name, color }) => ({
        name,
        x: months,
        y: months.map((month) => countsByStatusByMonth[month]?.[key] || 0),
        color,
        type:"line"
    }));
    const plotStatusTotalDataset = statusTypes.map(({ key, name, color }) => ({
        name,
        x: name,
        y: countsByStatus[key] || 0,
        color
    }));
    const plotTimeOfDayDataset = timeOfDayTypes.map(({ key, name, color }) => ({
        name,
        x: months,
        y: months.map((month) => countsByTimeOfDayByMonth[month]?.[key] || 0),
        color,
        type:"line"
    }));
    const plotTimeOfDayTotalDataset = timeOfDayTypes.map(({ key, name, color }) => ({
        name,
        x: name,
        y: countsByTimeOfDay[key] || 0,
        color
    }));

    const vesselStatusTypes = Object.keys(countsByVesselStatus).map((status, index) => ({
        key: status,
        name: status,
        color: `hsl(${(index * 60) % 360}, 70%, 50%)`,
        type:"line"
    }));

    const plotVesselStatusDataset = vesselStatusTypes.map(({ key, name, color }) => ({
        name,
        x: months,
        y: months.map((month) => countsByVesselStatusByMonth[month]?.[key] || 0),
        color,
        type:"line"
    }));

    const plotVesselStatusTotalDataset = vesselStatusTypes.map(({ key, name, color }) => ({
        name,
        x: name,
        y: countsByVesselStatus[key] || 0,
        color
    }));

    const vesselTypeTypes = Object.keys(countsByVesselType).map((type, index) => ({
        key: type,
        name: type,
        color: `hsl(${(index * 45) % 360}, 70%, 50%)`,
        type:"line"
    }));

    const plotVesselTypesDataset = vesselTypeTypes.map(({ key, name, color }) => ({
        name,
        x: months,
        y: months.map((month) => countsByVesselTypeByMonth[month]?.[key] || 0),
        color,
        type:"line"
    }));
    const plotVesselTypesTotalDataset = vesselTypeTypes.map(({ key, name, color }) => ({
        name,
        x: name,
        y: countsByVesselType[key] || 0,
        color
    }));

    const plotWeaponsDataset = weaponTypes.map(({ key, name, color }) => ({
        name,
        x: months,
        y: months.map((month) => countsByWeaponByMonth[month]?.[key] || 0),
        color,
        type:"line"
    }));

    const plotWeaponsTotalDataset = weaponTypes.map(({ key, name, color }) => ({
        name,
        x: name,
        y: countsByWeapon[key] || 0,
        color
    }));

    return {
        plotIncidents: plotIncidentsDataset,
        plotStatus: plotStatusDataset,
        plotStatusTotal: plotStatusTotalDataset,
        plotTimeOfDay: plotTimeOfDayDataset,
        plotTimeOfDayTotal: plotTimeOfDayTotalDataset,
        plotVesselStatus: plotVesselStatusDataset,
        plotVesselStatusTotal: plotVesselStatusTotalDataset,
        plotVesselTypes: plotVesselTypesDataset,
        plotVesselTypesTotal: plotVesselTypesTotalDataset,
        plotWeapons: plotWeaponsDataset,
        plotWeaponsTotal: plotWeaponsTotalDataset
    };
}

export function getTimeOfDayCategory(time_of_day) {
    if (!time_of_day) {
        return 'Unknown / not clear';
    }

    switch (time_of_day.toLowerCase()) {
        case 'afternoon':
        case 'evening':
        case 'midday':
        case 'morning':
            return 'day';
        case 'night':
            return 'night';
        case 'sunrise':
        case 'sunset':
            return 'sunriseset';
        default:
            return 'unknown';
    }
}